module.exports = __webpack_public_path__ + "img/gsll10cd.79c15c8d.jpg";